
<div class="container">


    <h2 class="content-heading">
  
       <button class="btn btn-sm btn-outline-secondary float-right" (click)="add()">
          <i class="fa fa-plus mr-5"></i>Add Pronunciation
        </button>
  
        Pronunciation
    </h2>
  
  
  <div class="blockX">
  
  
    <div class="block-contentX" *ngIf="isLoading==false">
  
        <div class=row>
  
            <div class="col-sm-5">
  
              Show
              <select (change)="changeNumberOfRecords()" [(ngModel)]="numberOfRecords">
                <option value=15>15</option>
                  <option value=30>30</option>
                  <option value=60>60</option>
                  <option value=99999>All</option>
              </select>
              entries
            </div>
  
            <div class="col-sm-7 text-right">

              <span style="margin-right:20px">
                Status: 
                <select (change)="changeActiveStatus()" [(ngModel)]="searchIsActive">
                  <option [ngValue]=null>All</option>
                  <option  [ngValue]=true>Active</option>
                  <option  [ngValue]=false>Inactive</option>
                </select>
              </span>

                Filter: <input type="text" [(ngModel)]="search"> 
            </div>
  
          </div>
  
  
    <div class="table-responsive table yearDataTable" xclass="table table-striped table-vcenter table-sm">
  
      <div class="xrow header gridRow row">
          <!-- <div class="col-md-2">Id</div> -->
          <div class="col-md-3">Name</div>
          <div class="col-md-5">HTML</div> 
          <div class="col-md-2 text-right">Is Active</div> 
          <div class="col-md-2  text-right">Actions</div>
      </div>
  
  
      <div id="scrollableTable">
        <div class="">
          <div *ngFor="let obj of entities | pronunciationFilter: search: searchIsActive | paginate: { itemsPerPage: numberOfRecords, currentPage: pageNumber }" class="dateRow gridRow row">
              <!-- <div class="col-md-2" >{{obj.Id}}</div> -->
              <div class="col-md-3">{{obj.Text}}</div>
              <div class="col-md-5">{{obj.PronunciationHtml}}</div> 
              <div class="col-md-2 text-right">{{obj.IsActive}}</div> 

            <div class="col-md-2 text-right" >
                <div class="col-md-4XX"> 
                  <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Edit" (click)="edit(obj)">
                    <i class="fa fa-pencil"></i>
                </button>
                <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Delete" (click)="delete(obj)">
                  <i class="fa fa-times"></i>
                </button>
                </div>
              </div>
          </div>
        </div>
      </div>
  
  </div>
  
  <div id="pageButtons" style="overflow: auto">
 
      {{ renderPaginationItemStatus(p) }} of {{ p.getTotalItems()}} entries
     
      <pagination-template #p="paginationApi" (pageChange)="pageNumber = $event" class="float-right">
       
        <div class="custom-pagination">
      
          <ul class="pagination pagination">
        
            <li class="page-item">
              <a class="page-link" *ngIf="!p.isFirstPage()" (click)="p.previous();">
                <i class="fa fa-angle-double-left"></i>
              </a>
            </li>
      
            <li class="page-item" *ngFor="let page of p.pages" [class.active]="p.getCurrent() === page.value">
              <a class="page-link" (click)="p.setCurrent(page.value);" *ngIf="p.getCurrent() !== page.value">
                <span>{{ page.label }}</span>
              </a>
              <a class="page-link" *ngIf="p.getCurrent() === page.value">
                <span>{{ page.label }}</span>
              </a>
            </li>
      
            <li class="page-item">
              <a class="page-link"  *ngIf="!p.isLastPage()" (click)="p.next();">
                  <i class="fa fa-angle-double-right"></i>
              </a>
            </li>
     
    
         
      
          </ul> 
      
        </div>
      
      </pagination-template>
    
      </div>
    
 
          </div>
  
  
  
          <app-progress-bar *ngIf="isLoading==true"></app-progress-bar>
    </div>
  
  </div>
  
  
  